angular.module('moebiusProadapt').controller('ctrlEtudeAddParticipant',
    ['$scope', '$rootScope', '$http', '$location', '$uibModal', 'moment', 'promiseTracker', 'mbsEtiService', 'mbsUser', 'participant', 'eti', function ($scope, $rootScope, $http, $location, $uibModal, moment, promiseTracker, mbsEtiService, mbsUser, participant, eti) {

        $scope.participantTracker      = promiseTracker('participantTracker');
        $scope.participant  = participant;
        $scope.eti          = eti;

        $scope.isEnabledForm  = function(participant) {
            if (
                    // !participant.numero ||
                 !participant.initiale_prenom ||
                 !participant.initiale_nom ||
                 _.isUndefined(participant.is_optimized) ||
                 (!participant.centre_id && !mbsUser.user.centre_id) ||
                 !participant.numero ||
                  !participant.annee_naissance ||
                  _.isUndefined(participant.sexe)
            ) {
                return false;
            }
            return true;
        };


        $scope.$watch('participant.centre_id', function (nv) {
            if (nv == $rootScope.constants.misc_constants.TEST_CENTER_ID) {
                var uniq = moment(new Date()).utc().unix();
                participant.numero = -1*uniq;
            }
        })

        $scope.addParticipant = function(participant) {
            if (!participant.centre_id) {
                participant.centre_id = mbsUser.user.centre_id;
            }

//            postSaveParticipantValues($etiId, $visiteKey, $participantId='new')
            var firstVisiteKey = mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys[0];
            var promise = $http.post('etude-instance/save-participant-values/' + mbsEtiService.getCurrentEti().id + '/' + firstVisiteKey + '/' + 'new', participant)
                .then(function (r) {
                    $scope.$close(r.data);
                });
            $scope.participantTracker.addPromise(promise);
            return $scope.participantTracker;
        }

    }]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/etudeAddParticipant.js